/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Hinton_TextInputs */

const en_home_quotes_hinton_text = /** @type {(inputs: Home_Quotes_Hinton_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you take the existential risk seriously, as I now do, it might be quite sensible to just stop developing these things any further.`)
};

/**
* | output |
* | --- |
* | "If you take the existential risk seriously, as I now do, it might be quite sensible to just stop developing these things any further." |
*
* @param {Home_Quotes_Hinton_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_hinton_text = /** @type {((inputs?: Home_Quotes_Hinton_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Hinton_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_hinton_text(inputs)
});